const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRole8292139(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.995 511.995",
    style: {
      enableBackground: "new 0 0 511.995 511.995"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 255.998,
    cy: 65.207,
    r: 57.707
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 198.291,
    y1: 176.03,
    x2: 198.291,
    y2: 231.361
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 313.704,
    y1: 176.03,
    x2: 313.704,
    y2: 231.361
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M315.489,446.162V354.24c0-8.696-7.05-15.745-15.745-15.745h-87.491c-8.696,0-15.746,7.05-15.746,15.745V488.75 c0,8.696,7.05,15.746,15.746,15.746h44.903L315.489,446.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M257.155,461.907v42.588l58.333-58.333h-42.588C264.205,446.162,257.155,453.211,257.155,461.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M150.628,446.162V354.24c0-8.696-7.05-15.745-15.745-15.745H47.391c-8.696,0-15.746,7.05-15.746,15.745V488.75 c0,8.696,7.05,15.746,15.746,15.746h44.903L150.628,446.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M92.295,461.907v42.588l58.333-58.333H108.04C99.344,446.162,92.295,453.211,92.295,461.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M422.016,461.907v42.588l58.333-58.333h-42.588C429.066,446.162,422.016,453.211,422.016,461.907z"
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 255.998,
    y1: 238.763,
    x2: 255.998,
    y2: 335.763
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M420.858,335.763v-36.197c0-6.795-5.508-12.303-12.303-12.303H103.44c-6.795,0-12.303,5.508-12.303,12.303v36.197"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M480.349,377.473V354.24c0-8.696-7.05-15.745-15.745-15.745h-87.491c-8.696,0-15.746,7.05-15.746,15.745v134.509 c0,8.696,7.05,15.746,15.746,15.746h44.903l58.333-58.333v-33.689"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2162e3",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M356.984,174.842v-4.067c0-26.324-21.538-47.862-47.862-47.862h-106.25c-26.324,0-47.861,21.537-47.861,47.861v53.855 c0,5.597,4.537,10.134,10.134,10.134H346.85c5.597,0,10.134-4.537,10.134-10.134v-14.788"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole8292139);
export default __webpack_public_path__ + "static/media/role_8292139.cac7b3db35837a66405e993396c00535.svg";
export { ForwardRef as ReactComponent };